import React from 'react';

import ServiceClient from 'bz-stores/lib/JsonServiceClient';

export const useServiceClient = (root: string = '/api') => {
  const [api] = React.useState(() => new ServiceClient(root));
  return api;
};
